<template>
	<div class="custom-page">
		<ContainerObject
			v-if="outOfPlaysPage"
			:containerObject="outOfPlaysPage.layout"
		/>
		<div v-else class="fallback">
			<div class="fallback-content">
				<div class="fallback-icon">🎮</div>
				<h1 class="fallback-title">Out of Plays</h1>
				<p class="fallback-message">You've used all your available plays for now. Check back later or contact support if you think this is a mistake.</p>
			</div>
		</div>
	</div>
</template>

<script lang="ts">
import ContainerObject from "@/components/layout/ContainerObject.vue";
import { CustomPage } from "@/types/customPage";
import { defineComponent } from "vue";
import { customPageStore } from "@/store/pinia_modules/customPageStore";

export default defineComponent({
	components: { ContainerObject },
	computed: {
		outOfPlaysPage(): CustomPage | undefined {
			return customPageStore().getPageByURL("out-of-plays");
		},
	},
});
</script>

<style scoped lang="scss">
.custom-page {
	position: relative;
	width: 100%;
	height: 100%;
}

.fallback {
	width: 100%;
	height: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
	background-color: #000;
	color: #fff;
}

.fallback-content {
	text-align: center;
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 16px;
	padding: 32px;
	max-width: 360px;
}

.fallback-icon {
	font-size: 3rem;
}

.fallback-title {
	font-size: 1.6rem;
	font-weight: 700;
	margin: 0;
}

.fallback-message {
	font-size: 1rem;
	color: #aaa;
	line-height: 1.5;
	margin: 0;
}
</style>
